import { render, staticRenderFns } from "./float-zixunjianyi.vue?vue&type=template&id=4606900c&"
import script from "./float-zixunjianyi.vue?vue&type=script&lang=js&"
export * from "./float-zixunjianyi.vue?vue&type=script&lang=js&"
import style0 from "./float-zixunjianyi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports